import React from 'react'
import { Link } from 'gatsby'
import './header.scss'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

interface HeaderProps {
  readonly title: string
  readonly children?: React.ReactNode | readonly React.ReactNode[]
  readonly toggleMenu: () => void
}

const Header = (props: HeaderProps) => {
  const breakpoints = useBreakpoint()
  return (
    <header className={'la-page-header'}>
      <button
        className={'la-page-header__burger'}
        onClick={() => {
          props.toggleMenu()
        }}
      >
        <i />
      </button>

      <div className={'la-page-header__left'}>
        <Link className={'la-page-header__logo'} to="/" />

        <span className={'la-page-header__label'}>{props.title}</span>
      </div>

      <div className={'la-page-header__center'}>{props.children}</div>

      {!breakpoints.sm || !breakpoints.portrait ? (
        <div className={'la-page-header__right'}>
          <div className={'la-social-network-list'}>
            <Link
              to="http://www.facebook.com/liveactionit"
              target={'blank'}
              className="la-social-network-list__item la-icon la-icon_facebook"
            />

            <Link
              to="http://twitter.com/liveactionit"
              target={'blank'}
              className="la-social-network-list__item la-icon la-icon_twitter"
            />

            <Link
              to="https://www.instagram.com/liveactionit/"
              target={'blank'}
              className="la-social-network-list__item la-icon la-icon_instagram"
            />

            <Link
              to="https://www.youtube.com/user/actionpackednetworks"
              target={'blank'}
              className="la-social-network-list__item la-icon la-icon_youtube"
            />
          </div>
        </div>
      ) : null}
    </header>
  )
}

export default Header
